import React, {useCallback} from 'react';
import FormContextProvider from 'contexts/form-context';
import {useDispatch} from 'react-redux';
import {useNewEmptyIllustration} from 'hooks/illustrator';
import {withProductComparisonList} from 'hooks/product-comparison';
import {widgetProductsQueryKey} from 'constants/query';
import {updateSelectedIllustration} from 'reducers/illustrator.reducer';
import {useCalculatorValidationSchema} from '../useCalculatorValidationSchema';
import CalculatorFormElement from '../calculator-form/CalculatorFormElement';
import Item from 'components/common/layout/item/Item';
import ProductsWidget from 'pages/widgets-page/calculator-page/components/products-widget/ProductsWidget';
import {EXCLUDE_ILLUSTRATOR_WARNING_MESSAGES} from 'constants/illustrator';
import CalculationWarnings from 'components/illustrator/calculation-warnings/CalculationWarnings';
import {pickUpdatingProductIllustrationContext, recordUpdatingWidgetCalculation} from 'lib/illustration-audit';
import {pick} from 'lodash';

const WIDGET_BORROWER_INPUT_KEYS = ['DateOfBirth', 'ValueOfProperty', 'Liens', 'Zip'];

CalculatorForm.propTypes = {};

function CalculatorForm(props) {
  const {data: {Calculations} = {}, loading, products} = props;

  const dispatch = useDispatch();
  const {defaultValues} = useNewEmptyIllustration({});
  const plainDefaultValues = JSON.parse(JSON.stringify(defaultValues));

  const onSubmit = useCallback(
    async (data) => {
      dispatch(updateSelectedIllustration(data));
      const result = await props.refetch();

      const responseData = result?.data;
      if (responseData) {
        const responseCalculations = responseData.Calculations ?? [];
        const {calculationId} = pickUpdatingProductIllustrationContext(responseCalculations, products);

        recordUpdatingWidgetCalculation({
          borrowerProfileId: responseData.BorrowerProfileId ?? data?.BorrowerProfile?.BorrowerProfileId,
          calculationId,
          widgetInputs: {
            ...pick(data?.BorrowerProfile, WIDGET_BORROWER_INPUT_KEYS),
            OverrideClosingCosts: data?.OverrideClosingCosts,
            ClosingCost: data?.ClosingCost,
          },
          calculations: responseCalculations
            .filter((calculation) => calculation.CalculationId)
            .map((calculation) => ({
              productSelected: products.find((product) => product.ProductId === calculation.ProductId)?.ApiRoute ?? null,
              calculationId: calculation.CalculationId,
            })),
        });
      }
    },
    [dispatch, props.refetch, products],
  );

  const {validationSchema} = useCalculatorValidationSchema();

  return (
    <>
      <Item xs={12}>
        <FormContextProvider defaultState={{validationSchema}}>
          <CalculatorFormElement onSubmit={onSubmit} defaultValues={plainDefaultValues} loading={loading} />
        </FormContextProvider>
        <CalculationWarnings
                      products={products}
                      exclude={EXCLUDE_ILLUSTRATOR_WARNING_MESSAGES}
                      loading={loading}
                    />
      </Item>

      <Item xs={12}>
        <ProductsWidget Calculations={Calculations} />
      </Item>
    </>
  );
}

export default withProductComparisonList(CalculatorForm, {
  includeAllProducts: true,
  productsQueryKey: widgetProductsQueryKey,
});
